// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPhoneInfoDto } from './IPhoneInfoDto';
import {
    IPhoneInfoDtoFromJSON,
    IPhoneInfoDtoFromJSONTyped,
    IPhoneInfoDtoToJSON,
    IPhoneInfoDtoToJSONTyped,
} from './IPhoneInfoDto';
import type { IAddressInfoDto } from './IAddressInfoDto';
import {
    IAddressInfoDtoFromJSON,
    IAddressInfoDtoFromJSONTyped,
    IAddressInfoDtoToJSON,
    IAddressInfoDtoToJSONTyped,
} from './IAddressInfoDto';
import type { IMobileAppThemeDto } from './IMobileAppThemeDto';
import {
    IMobileAppThemeDtoFromJSON,
    IMobileAppThemeDtoFromJSONTyped,
    IMobileAppThemeDtoToJSON,
    IMobileAppThemeDtoToJSONTyped,
} from './IMobileAppThemeDto';

/**
 * 
 * @export
 * @interface IEmployeeViewDto
 */
export interface IEmployeeViewDto {
    /**
     * 
     * @type {number}
     * @memberof IEmployeeViewDto
     */
    person_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeViewDto
     */
    preferred_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeViewDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeViewDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeViewDto
     */
    employee_provided_email?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeViewDto
     */
    employer_provided_email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeViewDto
     */
    is_employee_email_preferred?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeViewDto
     */
    preferred_email?: string;
    /**
     * 
     * @type {Date}
     * @memberof IEmployeeViewDto
     */
    hire_on?: Date;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeViewDto
     */
    claim_autopay_type?: IEmployeeViewDtoClaimAutopayTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeViewDto
     */
    default_claim_payee_type?: IEmployeeViewDtoDefaultClaimPayeeTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IEmployeeViewDto
     */
    termination_date?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeViewDto
     */
    is_electronic_statement_only?: boolean;
    /**
     * 
     * @type {IPhoneInfoDto}
     * @memberof IEmployeeViewDto
     */
    preferred_phone?: IPhoneInfoDto;
    /**
     * 
     * @type {IPhoneInfoDto}
     * @memberof IEmployeeViewDto
     */
    phone?: IPhoneInfoDto;
    /**
     * 
     * @type {IPhoneInfoDto}
     * @memberof IEmployeeViewDto
     */
    employee_provided_phone?: IPhoneInfoDto;
    /**
     * 
     * @type {IPhoneInfoDto}
     * @memberof IEmployeeViewDto
     */
    employer_provided_phone?: IPhoneInfoDto;
    /**
     * 
     * @type {number}
     * @memberof IEmployeeViewDto
     */
    citizenship_country_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeViewDto
     */
    citizenship_country_alpha2?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeViewDto
     */
    is_sso_user?: boolean;
    /**
     * 
     * @type {IMobileAppThemeDto}
     * @memberof IEmployeeViewDto
     */
    mobile_app_theme?: IMobileAppThemeDto;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeViewDto
     */
    is_verified_phone_number?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeViewDto
     */
    is_verified_employee_email?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeViewDto
     */
    is_verified_employer_email?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeViewDto
     */
    is_sms_notification_enabled?: boolean;
    /**
     * 
     * @type {Set<IAddressInfoDto>}
     * @memberof IEmployeeViewDto
     */
    addresses?: Set<IAddressInfoDto>;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeViewDto
     */
    is_created_by_orphan?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeViewDto
     */
    is_orphaned?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IEmployeeViewDtoClaimAutopayTypeEnum {
    AUTO = 'AUTO',
    CLICK = 'CLICK'
}
/**
* @export
* @enum {string}
*/
export enum IEmployeeViewDtoDefaultClaimPayeeTypeEnum {
    PARTICIPANT = 'PARTICIPANT',
    PROVIDER = 'PROVIDER',
    EMPLOYEE_CHOICE = 'EMPLOYEE_CHOICE'
}


/**
 * Check if a given object implements the IEmployeeViewDto interface.
 */
export function instanceOfIEmployeeViewDto(value: object): value is IEmployeeViewDto {
    return true;
}

export function IEmployeeViewDtoFromJSON(json: any): IEmployeeViewDto {
    return IEmployeeViewDtoFromJSONTyped(json, false);
}

export function IEmployeeViewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeeViewDto {
    if (json == null) {
        return json;
    }
    return {
        
        'person_id': json['person_id'] == null ? undefined : json['person_id'],
        'preferred_name': json['preferred_name'] == null ? undefined : json['preferred_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'employee_provided_email': json['employee_provided_email'] == null ? undefined : json['employee_provided_email'],
        'employer_provided_email': json['employer_provided_email'] == null ? undefined : json['employer_provided_email'],
        'is_employee_email_preferred': json['is_employee_email_preferred'] == null ? undefined : json['is_employee_email_preferred'],
        'preferred_email': json['preferred_email'] == null ? undefined : json['preferred_email'],
        'hire_on': json['hire_on'] == null ? undefined : (new Date(json['hire_on'])),
        'claim_autopay_type': json['claim_autopay_type'] == null ? undefined : json['claim_autopay_type'],
        'default_claim_payee_type': json['default_claim_payee_type'] == null ? undefined : json['default_claim_payee_type'],
        'termination_date': json['termination_date'] == null ? undefined : (new Date(json['termination_date'])),
        'is_electronic_statement_only': json['is_electronic_statement_only'] == null ? undefined : json['is_electronic_statement_only'],
        'preferred_phone': json['preferred_phone'] == null ? undefined : IPhoneInfoDtoFromJSON(json['preferred_phone']),
        'phone': json['phone'] == null ? undefined : IPhoneInfoDtoFromJSON(json['phone']),
        'employee_provided_phone': json['employee_provided_phone'] == null ? undefined : IPhoneInfoDtoFromJSON(json['employee_provided_phone']),
        'employer_provided_phone': json['employer_provided_phone'] == null ? undefined : IPhoneInfoDtoFromJSON(json['employer_provided_phone']),
        'citizenship_country_id': json['citizenship_country_id'] == null ? undefined : json['citizenship_country_id'],
        'citizenship_country_alpha2': json['citizenship_country_alpha2'] == null ? undefined : json['citizenship_country_alpha2'],
        'is_sso_user': json['is_sso_user'] == null ? undefined : json['is_sso_user'],
        'mobile_app_theme': json['mobile_app_theme'] == null ? undefined : IMobileAppThemeDtoFromJSON(json['mobile_app_theme']),
        'is_verified_phone_number': json['is_verified_phone_number'] == null ? undefined : json['is_verified_phone_number'],
        'is_verified_employee_email': json['is_verified_employee_email'] == null ? undefined : json['is_verified_employee_email'],
        'is_verified_employer_email': json['is_verified_employer_email'] == null ? undefined : json['is_verified_employer_email'],
        'is_sms_notification_enabled': json['is_sms_notification_enabled'] == null ? undefined : json['is_sms_notification_enabled'],
        'addresses': json['addresses'] == null ? undefined : (new Set((json['addresses'] as Array<any>).map(IAddressInfoDtoFromJSON))),
        'is_created_by_orphan': json['is_created_by_orphan'] == null ? undefined : json['is_created_by_orphan'],
        'is_orphaned': json['is_orphaned'] == null ? undefined : json['is_orphaned'],
    };
}

export function IEmployeeViewDtoToJSON(json: any): IEmployeeViewDto {
    return IEmployeeViewDtoToJSONTyped(json, false);
}

export function IEmployeeViewDtoToJSONTyped(value?: IEmployeeViewDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'person_id': value['person_id'],
        'preferred_name': value['preferred_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'employee_provided_email': value['employee_provided_email'],
        'employer_provided_email': value['employer_provided_email'],
        'is_employee_email_preferred': value['is_employee_email_preferred'],
        'preferred_email': value['preferred_email'],
        'hire_on': value['hire_on'] == null ? undefined : ((value['hire_on']).toISOString()),
        'claim_autopay_type': value['claim_autopay_type'],
        'default_claim_payee_type': value['default_claim_payee_type'],
        'termination_date': value['termination_date'] == null ? undefined : ((value['termination_date']).toISOString()),
        'is_electronic_statement_only': value['is_electronic_statement_only'],
        'preferred_phone': IPhoneInfoDtoToJSON(value['preferred_phone']),
        'phone': IPhoneInfoDtoToJSON(value['phone']),
        'employee_provided_phone': IPhoneInfoDtoToJSON(value['employee_provided_phone']),
        'employer_provided_phone': IPhoneInfoDtoToJSON(value['employer_provided_phone']),
        'citizenship_country_id': value['citizenship_country_id'],
        'citizenship_country_alpha2': value['citizenship_country_alpha2'],
        'is_sso_user': value['is_sso_user'],
        'mobile_app_theme': IMobileAppThemeDtoToJSON(value['mobile_app_theme']),
        'is_verified_phone_number': value['is_verified_phone_number'],
        'is_verified_employee_email': value['is_verified_employee_email'],
        'is_verified_employer_email': value['is_verified_employer_email'],
        'is_sms_notification_enabled': value['is_sms_notification_enabled'],
        'addresses': value['addresses'] == null ? undefined : (Array.from(value['addresses'] as Set<any>).map(IAddressInfoDtoToJSON)),
        'is_created_by_orphan': value['is_created_by_orphan'],
        'is_orphaned': value['is_orphaned'],
    };
}

